import axios from "axios";


const teste = 'http://127.0.0.1:5006'

export default axios.create({
  baseURL: process.env.REACT_APP_URL_API_MESSAGER,
})